import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface ActiveDetectorJob {
  jobId: string;
  runId: string;
  status: 'queued' | 'pending' | 'running' | 'done' | 'error';
  progress: number;
  stage: string;
  message: string;
  originalFilename: string;
  startedAt: string; // ISO timestamp
}

interface AiRunStore {
  activeDetectorJob: ActiveDetectorJob | null;
  setActiveDetectorJob: (job: ActiveDetectorJob) => void;
  updateActiveDetectorJob: (updates: Partial<ActiveDetectorJob>) => void;
  clearActiveDetectorJob: () => void;
}

export const useAiRunStore = create<AiRunStore>()(
  persist(
    (set) => ({
      activeDetectorJob: null,

      setActiveDetectorJob: (job) => set({ activeDetectorJob: job }),

      updateActiveDetectorJob: (updates) =>
        set((state) => ({
          activeDetectorJob: state.activeDetectorJob
            ? { ...state.activeDetectorJob, ...updates }
            : null,
        })),

      clearActiveDetectorJob: () => set({ activeDetectorJob: null }),
    }),
    {
      name: 'ai-run-storage',
    }
  )
);
